var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardcard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FEF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 15H14.1667C13.2462 15 12.5 15.7462 12.5 16.6667V23.3333C12.5 24.2538 13.2462 25 14.1667 25H25.8333C26.7538 25 27.5 24.2538 27.5 23.3333V16.6667C27.5 15.7462 26.7538 15 25.8333 15Z",
    stroke: "url(#paint0_linear_3_5103)",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.3333H27.5",
    stroke: "url(#paint1_linear_3_5103)",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 21.6667H19.1673",
    stroke: "url(#paint2_linear_3_5103)",
    strokeWidth: 1.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_5103",
    x1: 20,
    y1: 15,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_5103",
    x1: 20,
    y1: 18.3333,
    x2: 20,
    y2: 19.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_5103",
    x1: 17.5007,
    y1: 21.6667,
    x2: 17.5007,
    y2: 22.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardcard1);
export default __webpack_public_path__ + "static/media/dashboard card 1.f25c873d7b117f315cb24565c0083bf2.svg";
export { ForwardRef as ReactComponent };